<template>
  <div>
    <label class="label">{{ label }}</label>

    <label class="input">
      <i v-if="hasIcon" class="icon-append" :class="icon"></i>
      <input
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        :class="{ 'text-input-error': hasError }"
        :placeholder="placeholder"
        :disabled="isDisabled"
        :id="id"
        type="password"
      />
    </label>
    <p v-if="hasError && !hideErrorText" class="text-danger">{{ error }}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: [Number, String, Boolean],

    id: {
      type: String,
      default: ""
    },

    placeholder: {
      type: String,
      default: ""
    },

    label: {
      type: String,
      default: ""
    },

    hasError: {
      type: Boolean,
      default: false
    },

    error: {
      type: String,
      default: ""
    },

    hideErrorText: {
      type: Boolean,
      default: false
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: ""
    }
  },

  computed: {
    hasIcon() {
      return this.icon.length > 0;
    }
  }
};
</script>
